import { useCalculateFetchedItems } from '../../hooks/useCalculateFetchItems';
import { useScrollFetchData } from '../../hooks/useScrollFetchData';
import { useMediaQuery, useTheme } from '@mui/material';
import MachineCardViewData from './machineCardViewData';
import { PersistedFixedSizeList as List } from '../../hooks/listNavigation';
import React, { useEffect, useState } from 'react';
import '../../css/machines/GridView.css';
import { debounce } from 'lodash';

const GridView = React.memo(({ scrollRef, machines, setOffset, filteredMachinesCount, setMachinesFetched }) => {

    const theme = useTheme();
    const isXs = useMediaQuery(theme.breakpoints.only('xs'));
    const isSm = useMediaQuery(theme.breakpoints.only('sm'));
    const isMd = useMediaQuery(theme.breakpoints.only('md'));
    const isLg = useMediaQuery(theme.breakpoints.only('lg'));
    const isXl = useMediaQuery(theme.breakpoints.only('xl'));

    // Determine the number of columns based on screen size
    const getColumns = () => {
        if (isXs) return 1;
        if (isSm) return 2;
        if (isMd) return 3;
        if (isLg) return 4;
        if (isXl) return 4;
        return 5; // Default
    };

    const columns = getColumns();

    const [windowHeight, setWindowHeight] = useState(window.innerHeight);

    // Update window height on resize
    useEffect(() => {
        const handleResize = debounce(() => {
            setWindowHeight(window.innerHeight);
        }, 300); // 300ms debounce delay

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
            handleResize.cancel(); // Cancel any pending debounced calls
        };
    }, []);

    // Calculate the number of rows based on the number of machines and columns
    const rowCount = Math.ceil(filteredMachinesCount / columns);

    // Calculate fetched items on mount
    useCalculateFetchedItems(filteredMachinesCount, setMachinesFetched, 385, 260, columns);

    // Handle scroll and fetch more items
    const handleScrollCard = useScrollFetchData(setOffset, setMachinesFetched, filteredMachinesCount, 385, 260, columns);

    const Row = ({ index, style, data }) => {
        const { machines, columns, filteredMachinesCount } = data;
        return (
            <div key={index} style={style}>
                <MachineCardViewData
                    index={index}
                    data={{ machines, columns, filteredMachinesCount }}
                />
            </div>
        );
    };

    return (
        <List
            ref={scrollRef}
            height={windowHeight - 260}
            width='100%'
            itemCount={rowCount}
            itemSize={385}
            itemData={{ machines, columns, filteredMachinesCount }}
            onScroll={handleScrollCard}
        >
            {Row}
        </List>
    );
});

export default GridView;